// extracted by mini-css-extract-plugin
export default {"root":"ResendRow_root__SPJTZ","resend":"ResendRow_resend__9nJfa","timer":"ResendRow_timer__6AAuL"};